import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import UnifiedComputeResource from '../UnifiedCompute.resource';
import NavigationService from '@ane/core/lib/services/NavigationService';
import { ComputeRouteUtils } from '@ane/exp-data/lib/routes/ComputeRoute.utils';
export const defaultReducerState = {
    res: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'putCompute';
const CLEAR_GET_COMPUTE_STATE = `${prefix}/CLEAR_STATE`;
export const clearPutComputeState = () => {
    return {
        type: CLEAR_GET_COMPUTE_STATE,
        payload: {},
    };
};
const putComputeArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['res'],
    loadResource: (inputPayload) => {
        return UnifiedComputeResource.putCompute(inputPayload.workspaceId, inputPayload.compute);
    },
    onCompleteSuccess: (resourceResult, inputPayload) => {
        NavigationService.navigateTo(ComputeRouteUtils.routes.view.getURL({ id: inputPayload.compute.id }));
        return resourceResult;
    },
};
export const putComputeEpicReducer = loadResourcesUtils(putComputeArgs);
// Reducer
export const putComputeReducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case CLEAR_GET_COMPUTE_STATE:
            return defaultReducerState;
        default:
            return putComputeEpicReducer.reduxChange(state, action);
    }
};
export default putComputeReducer;

//# sourceMappingURL=PutCompute.ducks.js.map
